import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x-gray.svg'


const _hoisted_1 = {
  class: "flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full",
  style: {"background-color":"#1D8A56"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "h-4 w-4",
  alt: "close"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!

  return (_openBlock(), _createBlock("div", {
    class: "flex items-center gap-x-4 rounded-lg py-4 px-5",
    style: { width: _ctx.data.customWidth || '417px', backgroundColor: '#E6F7ED' }
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Icons, {
        name: "check",
        class: "w-4 text-white"
      })
    ]),
    _createVNode("div", {
      class: "min-w-0 flex-1 text-sm",
      style: {"color":"#1D8A56"},
      innerHTML: _ctx.data.message
    }, null, 8, ["innerHTML"]),
    _createVNode("button", {
      type: "button",
      class: "flex-shrink-0 p-1 transition-opacity hover:opacity-70",
      "aria-label": "Tutup",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
    }, [
      _hoisted_2
    ])
  ], 4))
}